<template>
  <span
    role="progressbar"
    class="lds-ring relative flex size-20 items-center justify-center"
  >
    <span />
    <span />
    <span />
    <span />
  </span>
</template>
